<template>
    <div>
        <b-modal
            :id="modalId"
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
        >
            <div class="qr-main">
                <div
                    id="profile-qrmodal-close-btn"
                    class="close-btn"
                    @click="hide()"
                >
                    <img src="@/assets/profile/close@2x.png" alt="" />
                </div>
                <div class="qr-header">
                    <div class="title-scc">
                        <h2>
                            {{ content.header }}
                        </h2>
                        <p class="text-black">
                            {{ content.description }}
                        </p>
                    </div>
                </div>
                <div class="point-container">
                    <div
                        class="qr-point"
                        :style="{
                            'background-image': 'url(' + pointBar + ')',
                        }"
                    >
                        <span>
                            <p>{{ content.condition }} คะแนน</p>
                        </span>
                        <img src="@/assets/profile/point-darkgray.svg" alt="" />
                    </div>
                </div>
                <div class="qr-code">
                    <p class="text-black">{{ content.QRcaption }}</p>
                    <vue-qrcode
                        v-if="strExpireTime != '00:00:00'"
                        id="qrcode"
                        :value="qrCode.code"
                        :options="objQrCodeConfig"
                    ></vue-qrcode>
                    <p v-if="strExpireTime != '00:00:00'" class="text-code">
                        {{ qrCode.code }}
                    </p>
                    <div v-if="strExpireTime == '00:00:00'" class="qr-expire">
                        รหัสหมดอายุ
                    </div>
                    <p class="counter text-black">
                        เหลือเวลา : {{ strExpireTime }}
                    </p>
                    <button
                        v-if="strExpireTime == '00:00:00'"
                        class="btn"
                        @click="newCode"
                    >
                        กดเพื่อแสดงคิวอาร์โค้ดใหม่
                    </button>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Moment from "moment";
import Locale from "@/helper/locale/locale.js";
//api
import BzbsApi from "@/core/Account/service/BzbsProfile.js";
import QRcodeApi from "@/module/List/service/PrivilegeApi.js";
//helper
import CacheHelper from "@/helper/CacheHelper.js";
//mixin
import Mixin from "@/mixin/Mixin";
// component
import VueQrcode from "@chenfengyuan/vue-qrcode";
/**
 * @property {AlertModalController} controller (required) /components/Modal/Controller/AlertModalController.js
 * @property {String} modalId (reqquired)
 */
export default {
    name: "QrModal",
    props: {
        // busModal: Object,
        controller: Object,
        modalId: String,
    },
    mixins: [Mixin],
    components: { VueQrcode },
    data: function () {
        return {
            cacheHelper: new CacheHelper(),
            busModal: null,
            lbl: Locale.getLbl(),

            pointBar: require("@/assets/profile/group-point-new-theme.png"),

            qrCode: [],
            content: {},

            strExpireTime: null,
            interval: null,
            timer: null,
            expirein: null,
            profile: {},
            objQrCodeConfig: {
                width: 160,
                margin: 0,
            },
        };
    },
    created: function () {
        this.busModal = this.controller.busModal;
        this.getblob();
    },
    mounted: function () {
        this.busModal.$on("show", this.show);
        this.busModal.$on("hide", this.hide);
        this.busModal.$on("setProfile", this.setProfile);
    },
    methods: {
        getblob() {
            QRcodeApi.GetBlob().then((response) => {
                this.content = response[0];
            });
        },
        getQRCode(profile) {
            return new Promise((resolve, reject) => {
                var ewallet_token =
                    this.cacheHelper.getCache("BzbsUser").detail.ewallet_token;
                var params = {
                    mac_address: profile.UserId,
                };
                BzbsApi.apiGetQRCode(params, ewallet_token).subscribe(
                    (result) => {
                        resolve(result);
                    },
                    (err) => {
                        this.errorResponse(err);
                        reject(err);
                    }
                );
            });
        },
        clickOk: function () {
            window.location.href = this.link;
            this.hide();
            this.controller.sendCallbackOk({ tag: this.tag });
        },
        setProfile(profile) {
            this.profile = profile;
        },
        show: function () {
            this.handleLoading(true);
            this.getQRCode(this.profile).then((result) => {
                this.qrCode = result;
                this.runInterval();
                setTimeout(() => {
                    this.handleLoading(false);
                    this.$bvModal.show(this.modalId);
                }, 1000);
            });
        },
        hide: function () {
            this.$bvModal.hide(this.modalId);
        },
        runInterval() {
            this.timer = Moment();
            this.expirein = Moment().add(this.qrCode.expirein, "seconds");
            setInterval(() => {
                this.runClockSerialInterval();
            }, 1000);
        },
        newCode() {
            this.hide();
            setTimeout(() => {
                this.show();
            }, 1000);
        },
        runClockSerialInterval() {
            var difference = this.expirein - Moment();
            if (difference <= 0) {
                this.strExpireTime = "00:00:00";
                this.cancelRunClockSerial();
                return;
            }

            var daysDiff = Math.floor(difference / 1000 / 60 / 60 / 24);
            difference -= daysDiff * 1000 * 60 * 60 * 24;
            if (daysDiff <= 9) {
                daysDiff = "0" + daysDiff;
            }

            var hoursDiff = Math.floor(difference / 1000 / 60 / 60);
            difference -= hoursDiff * 1000 * 60 * 60;
            if (hoursDiff <= 9) {
                hoursDiff = "0" + hoursDiff;
            }

            var minsDiff = Math.floor(difference / 1000 / 60);
            difference -= minsDiff * 1000 * 60;
            if (minsDiff <= 9) {
                minsDiff = "0" + minsDiff;
            }

            var secsDiff = "" + Math.floor(difference / 1000);
            if (secsDiff <= 9) {
                secsDiff = "0" + secsDiff;
            }

            if (parseInt(daysDiff) <= 0) {
                if (parseInt(hoursDiff) <= 0) {
                    if (parseInt(minsDiff) <= 0) {
                        if (parseInt(secsDiff) <= 0) {
                            this.strExpireTime = "00:00:00";
                        } else {
                            this.strExpireTime = "00:00:" + secsDiff;
                        }
                    } else {
                        this.strExpireTime = "00:" + minsDiff + ":" + secsDiff;
                    }
                } else {
                    this.strExpireTime =
                        hoursDiff + ":" + minsDiff + ":" + secsDiff;
                }
            } else {
                this.strExpireTime =
                    daysDiff +
                    ":" +
                    hoursDiff +
                    ":" +
                    minsDiff +
                    ":" +
                    secsDiff;
            }
        },
        cancelRunClockSerial() {
            clearInterval(this.runClockSerialInterval);
        },
    },
};
</script>
<style lang="scss" scoped>
@import "@/module/List/style/profile.scss";
</style>
